import {
  FloatConfigModule,
  LoansConfigModule,
  MpesaBulkConfigModule,
  MpesaPaybillConfigModule,
  MpesaTillConfigModule,
  SmsConfigModule,
} from '@enezatelecoms/eneza-models';

export class Reseller {
  public docId: string;
  public name: string; // The client (enterpsise, business, etc) full name
  public email: string;
  public resellerCode: string;

  public float: number;
  public availableFloat: FloatConfigModule;
  public walletBalance = 0;

  // contact person 1
  public phoneNumber: string;
  public firstName: string;
  public lastName: string;
  public secondaryEmail?: string;

  // company details
  public companyName: string;
  public companyBox: string;
  public companyPhone: string;
  public companyAddress: string;

  public dateCreated: any;
  public createdBy: string; // Current admin uid
  public createdByEmail: string;

  public lastUpdated: any;
  public updatedBy: string; // Current admin uid
  public updatedByEmail: string;

  public bankName: string;
  public bankBranch: string;
  public accountNumber: string;
  public swiftCode: string;

  public modules: any = {};

  public sendpasswordReset = false;

  public sms: SmsConfigModule;
  public loans: LoansConfigModule;
  public schoolLoans: LoansConfigModule;
  public securedLoans: LoansConfigModule;
  public mpesaBulk: MpesaBulkConfigModule;
  public mpesaPaybill: MpesaPaybillConfigModule;
  public mpesaTill: MpesaTillConfigModule;
}
